<template>
<div>
    <!-- Home Start-->
    <section class="main-header bg-header governance-banner-img">
        <div class="home-bg-img">
            <div class="container">
                <div>
                    <div class="item">
                        <div class="row align-items-center">
                            <div class="col-lg-7">
                                <div class="content wow fadeInUp" data-wow-delay="0.1s" data-wow-duration="1s">
                                    <h2 class="banner-title text-lg-left text-center text-white text-uppercase">
                                        I.T GOVERNANCE AND SECURITY READINESS ASSESSMENT
                                    </h2>
                                    <p class="text-white text-lg-left text-center para-txt font-weight-medium f-16">
                                        <b class="sub-title">At the end of 2021, cybercrime was projected to peak at the US $6 trillion annually.</b><br><br>No organization can ever claim total security of their system from hackers, phishing, and many other possible security intrusions. However, a system with the right infrastructure and safeguards can improve your ability to mitigate, detect, and timely resolve these intrusions.
                                    </p>
                                </div>
                            </div>
                            <sales-lead-form product="IT Governance and Security Readiness Assessment"> </sales-lead-form>

                        </div>
                    </div>

                </div>
            </div>
        </div>
    </section>

    <!-- End Services Top -->

    <!-- Start of testing section --->
    <div class="container">
        <div data-wow-delay="0.6s" data-wow-duration="1s" class="about-bottom-section mt-5 wow fadeInUp" style="visibility: visible; animation-duration: 1s; animation-delay: 0.6s;">
            <div class="title-section">
                <div class="subtitle-hr d-flex align-items-center">
                    <h6 class="subtitle theme-color text-uppercase position-relative">REGISTER NOW !!!</h6>
                    <hr>
                </div>

            </div>
            <div class="mt-4">
                <div class="row align-items-center">
                    <div class="col-lg-5"><img src="assets/images/assessments/security.jpg" alt="security.jpg" class="w-100 img-fluid"></div>
                    <div class="col-lg-7 mt-lg-0 mt-4">
                        <h1 class="font-sm-24">Information Technology Governance & Security Readiness Assessment</h1>
                        <p>Is your security program ready, and are your people and partners aware of the possible minefields?</p>
                        <p><b>Anchor’s readiness assessments position your company to:</b> </p>
                        <ul class="about-list list-unstyled pl-4 mb-0">
                            <li class="position-relative mb-4">Understand where you might have potential leaks</li>
                            <li class="position-relative mb-4">Determine and manage the culture of your organization towards risk</li>
                            <li class="position-relative">Evaluate the readiness of your security and data management professionals </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <section class="section">
        <div class="container">
            <div class="row align-items-baseline">

                <div data-wow-duration="1500ms" class="col-lg-6 wow fadeInUp" style="visibility: visible; animation-duration: 1500ms;">
                    <div class="title-section">
                        <div class="subtitle-hr d-flex align-items-center">
                            <h6 class="subtitle theme-color text-uppercase position-relative">About</h6>
                            <hr>
                        </div>
                        <h2 class="title text-md-left text-center f-40">Data & Privacy Readiness Assessment </h2>
                    </div>
                    <div class="mt-4">
                        <div id="accordion" data-wow-duration="1500ms" class="wow fadeInUp" style="visibility: visible; animation-duration: 1500ms;">
                            <div class="accordion-card bg-white mb-4 shadow rounded">
                                <div id="headingOne" class="card-header border-0 p-0">
                                    <h5 class="mb-0"><button data-toggle="collapse" data-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne" class="link-btn p-0 text-left border-0 bg-white w-100 d-flex justify-content-between align-items-center theme-color collapsed"><span class="font-weight-medium">Data Governance & Infrastructure </span><span><i class="mdi mdi-chevron-down d-flex f-30"></i></span></button></h5>
                                </div>
                                <div id="collapseOne" aria-labelledby="headingOne" data-parent="#accordion" class="collapse" style="">
                                    <div class="pt-2">
                                        <div class="service-box pt-4 d-flex align-items-start">
                                            <div class="services-info z-index">
                                                <p>Corporate Structure Readiness </p>
                                                <ul>
                                                    <li>Governance Assessment </li>
                                                    <li>Board Leadership </li>
                                                    <li>Management Buy-ins </li>
                                                    <li>Roles Allocation</li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="service-box pt-4 d-flex align-items-start">
                                            <div class="services-info z-index">
                                                <h6 class="text-secondary">Legislative Knowledge </h6>
                                                <ul>
                                                    <li>Legislative Readiness </li>
                                                    <li>Knowledge of Local Laws </li>
                                                    <li>Knowledge of Regional & International Laws </li>
                                                    <li>Knowledge of Legislative Metrics</li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="service-box pt-4 d-flex align-items-start">
                                            <div class="services-info z-index">
                                                <h6 class="text-secondary">Data & Privacy Policies </h6>
                                                <ul>
                                                    <li>Policy Framework </li>
                                                    <li>Policy Team </li>
                                                    <li>Policy Management</li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="service-box pt-4 d-flex align-items-start">
                                            <div class="services-info z-index">
                                                <h6 class="text-secondary">Data & Privacy Management </h6>
                                                <ul>
                                                    <li>Policy Framework </li>
                                                    <li>Policy Team </li>
                                                    <li>Policy Management</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="accordion-card bg-white mb-4 shadow rounded">
                                <div id="headingTwo" class="card-header border-0 p-0">
                                    <h5 class="mb-0"><button data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo" class="link-btn p-0 text-left border-0 bg-white w-100 d-flex justify-content-between align-items-center theme-color collapsed"><span class="font-weight-medium">Culture Building & Management </span><span><i class="mdi mdi-chevron-down d-flex f-30"></i></span></button></h5>
                                </div>
                                <div id="collapseTwo" aria-labelledby="headingTwo" data-parent="#accordion" class="collapse" style="">
                                    <div class="pt-2">
                                        <div class="service-box pt-4 d-flex align-items-start">
                                            <div class="services-info z-index">
                                                <p>Building a Data Governance Culture </p>
                                                <ul>
                                                    <li>Culture Setup </li>
                                                    <li>Staff Awareness Training Program </li>
                                                    <li>Ritualization + Formalization </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="service-box pt-4 d-flex align-items-start">
                                            <div class="services-info z-index">
                                                <h6 class="text-secondary">Tracking Data Governance Culture </h6>
                                                <ul>
                                                    <li>Dashboards & Metrics </li>
                                                    <li>Employee Engagement </li>
                                                    <li>Culture Champion </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="service-box pt-4 d-flex align-items-start">
                                            <div class="services-info z-index">
                                                <h6 class="text-secondary">Success Celebration </h6>
                                                <ul>
                                                    <li>Tone at Top </li>
                                                    <li>Recognition</li>
                                                    <li>Communication & Community </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="accordion-card bg-white mb-4 shadow rounded">
                                <div id="headingThree" class="card-header border-0 p-0">
                                    <h5 class="mb-0"><button data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree" class="link-btn p-0 text-left border-0 bg-white w-100 d-flex justify-content-between align-items-center theme-color collapsed"><span class="font-weight-medium"> Data & Privacy Management </span><span><i class="mdi mdi-chevron-down d-flex f-30"></i></span></button></h5>
                                </div>
                                <div id="collapseThree" aria-labelledby="headingThree" data-parent="#accordion" class="collapse">
                                    <div class="pt-2">
                                        <div class="service-box pt-4 d-flex align-items-start">
                                            <div class="services-info z-index">
                                                <h6 class="text-secondary">Data & Privacy Management:</h6>
                                                <p>Processing Management </p>
                                                <ul>
                                                    <li>Data Identification </li>
                                                    <li>Data Classification </li>
                                                    <li>Data Processors Identification </li>
                                                    <li>Data Flows Identification </li>
                                                    <li>Data Management Protocols</li>
                                                </ul>
                                            </div>
                                        </div>

                                        <div class="service-box pt-4 d-flex align-items-start">
                                            <div class="services-info z-index">
                                                <p>Data Subject Management </p>
                                                <ul>
                                                    <li>Knowledge of Data Subject </li>
                                                    <li>Knowledge of Data Subject Rights </li>
                                                    <li>Requests Management </li>
                                                    <li>Feedback and Complaints Management</li>
                                                </ul>
                                            </div>
                                        </div>

                                        <div class="service-box pt-4 d-flex align-items-start">
                                            <div class="services-info z-index">
                                                <p>Data Risk Management </p>
                                                <ul>
                                                    <li>Data Risk Assessment </li>
                                                    <li>Data Processor Risk Assessment </li>
                                                    <li>Risk Mitigation Strategy</li>
                                                </ul>
                                            </div>
                                        </div>

                                        <div class="service-box pt-4 d-flex align-items-start">
                                            <div class="services-info z-index">
                                                <p>Data Protection & Security </p>
                                                <ul>
                                                    <li>Identity Management </li>
                                                    <li>Authentication and Access Control </li>
                                                    <li>Data Maintenance & Security </li>
                                                    <li>Protective Technology </li>
                                                    <li>Data Protection & Security</li>
                                                    <li>Data Retention </li>
                                                    <li>Mitigation Methodology</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="accordion-card bg-white mb-4 shadow rounded">
                                <div id="headingFour" class="card-header border-0 p-0">
                                    <h5 class="mb-0"><button data-toggle="collapse" data-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour" class="link-btn p-0 text-left border-0 bg-white w-100 d-flex justify-content-between align-items-center theme-color collapsed"><span class="font-weight-medium">Data Breach Management </span><span><i class="mdi mdi-chevron-down d-flex f-30"></i></span></button></h5>
                                </div>
                                <div id="collapseFour" aria-labelledby="headingFour" data-parent="#accordion" class="collapse">
                                    <div class="pt-2">
                                        <div class="service-box pt-4 d-flex align-items-start">
                                            <div class="services-info z-index">
                                                <p>Data Breach Detection </p>
                                                <ul>
                                                    <li>Detection Program Oversight </li>
                                                    <li>Detection Processes & Protocols </li>
                                                    <li>Continuous Security Anomalies </li>
                                                    <li>Continuous Event Monitoring</li>
                                                </ul>
                                            </div>
                                        </div>

                                        <div class="service-box pt-4 d-flex align-items-start">
                                            <div class="services-info z-index">
                                                <p>Data Breach Response </p>
                                                <ul>
                                                    <li>Response Planning </li>
                                                    <li>Response Methodology </li>
                                                    <li>Communication and Training</li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="service-box pt-4 d-flex align-items-start">
                                            <div class="services-info z-index">
                                                <p>Data Recovery Management </p>
                                                <ul>
                                                    <li>Recovery Planning </li>
                                                    <li>Recovery Methodology </li>
                                                    <li>Communication and training</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="accordion-card bg-white mb-4 shadow rounded">
                                <div id="headingFive" class="card-header border-0 p-0">
                                    <h5 class="mb-0"><button data-toggle="collapse" data-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive" class="link-btn p-0 text-left border-0 bg-white w-100 d-flex justify-content-between align-items-center theme-color collapsed"><span class="font-weight-medium">Data Breach Management </span><span><i class="mdi mdi-chevron-down d-flex f-30"></i></span></button></h5>
                                </div>
                                <div id="collapseFive" aria-labelledby="headingFive" data-parent="#accordion" class="collapse">
                                    <div class="pt-2">
                                        <div class="service-box pt-4 d-flex align-items-start">
                                            <div class="services-info z-index">
                                                <p>Data Breach Detection </p>
                                                <ul>
                                                    <li>Detection Program Oversight </li>
                                                    <li>Detection Processes & Protocols </li>
                                                    <li>Continuous Security Anomalies </li>
                                                    <li>Continuous Event Monitoring</li>
                                                </ul>
                                            </div>
                                        </div>

                                        <div class="service-box pt-4 d-flex align-items-start">
                                            <div class="services-info z-index">
                                                <p>Data Breach Response </p>
                                                <ul>
                                                    <li>Response Planning </li>
                                                    <li>Response Methodology </li>
                                                    <li>Communication and Training</li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="service-box pt-4 d-flex align-items-start">
                                            <div class="services-info z-index">
                                                <p>Data Recovery Management </p>
                                                <ul>
                                                    <li>Recovery Planning </li>
                                                    <li>Recovery Methodology </li>
                                                    <li>Communication and training</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div data-wow-duration="1500ms" class="col-lg-6 wow fadeInUp" style="visibility: visible; animation-duration: 1500ms;">
                    <div class="title-section">
                        <div class="subtitle-hr d-flex align-items-center">
                            <h6 class="subtitle theme-color text-uppercase position-relative">About</h6>
                            <hr>
                        </div>
                        <h2 class="title text-md-left text-center f-40">IT Governance & Security Readiness Assessment </h2>
                    </div>
                    <div class="mt-4">
                        <div id="accordion" data-wow-duration="1500ms" class="wow fadeInUp" style="visibility: visible; animation-duration: 1500ms;">
                            <div class="accordion-card bg-white mb-4 shadow rounded">
                                <div id="heading6" class="card-header border-0 p-0">
                                    <h5 class="mb-0"><button data-toggle="collapse" data-target="#collapse6" aria-expanded="false" aria-controls="collapse6" class="link-btn p-0 text-left border-0 bg-white w-100 d-flex justify-content-between align-items-center theme-color collapsed"><span class="font-weight-medium">IT Governance </span><span><i class="mdi mdi-chevron-down d-flex f-30"></i></span></button></h5>
                                </div>
                                <div id="collapse6" aria-labelledby="heading6" data-parent="#accordion" class="collapse" style="">
                                    <div class="pt-2">
                                        <div class="service-box pt-4 d-flex align-items-start">
                                            <div class="services-info z-index">
                                                <p>Corporate Structure</p>
                                                <ul>
                                                    <li>Optimal Organizational Structure Review</li>
                                                    <li>Management Analysis</li>
                                                    <li>Roles Allocation</li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="service-box pt-4 d-flex align-items-start">
                                            <div class="services-info z-index">
                                                <h6 class="text-secondary">Risk Management</h6>
                                                <ul>
                                                    <li>Risk Framework </li>
                                                    <li>Business Continuity </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="service-box pt-4 d-flex align-items-start">
                                            <div class="services-info z-index">
                                                <h6 class="text-secondary">Security Training </h6>
                                            </div>
                                        </div>
                                        <div class="service-box pt-4 d-flex align-items-start">
                                            <div class="services-info z-index">
                                                <h6 class="text-secondary">Vendor Management </h6>
                                                <ul>
                                                    <li>Protocols </li>
                                                    <li>Monitoring</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="accordion-card bg-white mb-4 shadow rounded">
                                <div id="heading7" class="card-header border-0 p-0">
                                    <h5 class="mb-0"><button data-toggle="collapse" data-target="#collapse7" aria-expanded="false" aria-controls="collapse7" class="link-btn p-0 text-left border-0 bg-white w-100 d-flex justify-content-between align-items-center theme-color collapsed"><span class="font-weight-medium">Security & Privacy</span><span><i class="mdi mdi-chevron-down d-flex f-30"></i></span></button></h5>
                                </div>
                                <div id="collapse7" aria-labelledby="heading7" data-parent="#accordion" class="collapse" style="">
                                    <div class="pt-2">
                                        <div class="service-box pt-4 d-flex align-items-start">
                                            <div class="services-info z-index">
                                                <p>Identity & Access Management </p>
                                                <ul>
                                                    <li>Access Control </li>
                                                    <li>Access Monitoring </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="service-box pt-4 d-flex align-items-start">
                                            <div class="services-info z-index">
                                                <h6 class="text-secondary">Data Security & Privacy</h6>
                                                <ul>
                                                    <li>Data Management </li>
                                                    <li>Data Protection </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="service-box pt-4 d-flex align-items-start">
                                            <div class="services-info z-index">
                                                <h6 class="text-secondary">Wireless Network Security </h6>
                                                <ul>
                                                    <li>Network Management </li>
                                                    <li>Network Protection</li>
                                                </ul>
                                            </div>
                                        </div>

                                        <div class="service-box pt-4 d-flex align-items-start">
                                            <div class="services-info z-index">
                                                <h6 class="text-secondary">Incident Monitoring </h6>
                                                <ul>
                                                    <li>People & Policy</li>
                                                    <li>Monitoring & Improvement</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="accordion-card bg-white mb-4 shadow rounded">
                                <div id="heading8" class="card-header border-0 p-0">
                                    <h5 class="mb-0"><button data-toggle="collapse" data-target="#collapse8" aria-expanded="false" aria-controls="collapse8" class="link-btn p-0 text-left border-0 bg-white w-100 d-flex justify-content-between align-items-center theme-color collapsed"><span class="font-weight-medium"> Application & Device Management </span><span><i class="mdi mdi-chevron-down d-flex f-30"></i></span></button></h5>
                                </div>
                                <div id="collapse8" aria-labelledby="heading8" data-parent="#accordion" class="collapse">
                                    <div class="pt-2">
                                        <div class="service-box pt-4 d-flex align-items-start">
                                            <div class="services-info z-index">
                                                <p>Application Whitelisting </p>
                                                <ul>
                                                    <li>Whitelisting Management </li>
                                                </ul>
                                            </div>
                                        </div>

                                        <div class="service-box pt-4 d-flex align-items-start">
                                            <div class="services-info z-index">
                                                <p>Operating System</p>
                                                <ul>
                                                    <li>Operating System Management </li>
                                                </ul>
                                            </div>
                                        </div>

                                        <div class="service-box pt-4 d-flex align-items-start">
                                            <div class="services-info z-index">
                                                <p>User Applications </p>
                                                <ul>
                                                    <li>Application Management </li>
                                                    <li>Application Hardening </li>
                                                    <li>Application Patches</li>
                                                </ul>
                                            </div>
                                        </div>

                                        <div class="service-box pt-4 d-flex align-items-start">
                                            <div class="services-info z-index">
                                                <p>Device Management </p>
                                                <ul>
                                                    <li>Protocols Review </li>
                                                    <li>o Tracking & Reporting </li>
                                                </ul>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div class="accordion-card bg-white mb-4 shadow rounded">
                                <div id="heading9" class="card-header border-0 p-0">
                                    <h5 class="mb-0"><button data-toggle="collapse" data-target="#collapse9" aria-expanded="false" aria-controls="collapse9" class="link-btn p-0 text-left border-0 bg-white w-100 d-flex justify-content-between align-items-center theme-color collapsed"><span class="font-weight-medium">User Access Control </span><span><i class="mdi mdi-chevron-down d-flex f-30"></i></span></button></h5>
                                </div>
                                <div id="collapse9" aria-labelledby="heading9" data-parent="#accordion" class="collapse">
                                    <div class="pt-2">
                                        <div class="service-box pt-4 d-flex align-items-start">
                                            <div class="services-info z-index">
                                                <p>Administrator Access Management </p>
                                                <ul>
                                                    <li>Administrator Management </li>
                                                    <li>Administrator Authentication </li>
                                                </ul>
                                            </div>
                                        </div>

                                        <div class="service-box pt-4 d-flex align-items-start">
                                            <div class="services-info z-index">
                                                <p>User Access Management </p>
                                                <ul>
                                                    <li>User Management </li>
                                                    <li>Password Management </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="accordion-card bg-white mb-4 shadow rounded">
                                <div id="heading10" class="card-header border-0 p-0">
                                    <h5 class="mb-0"><button data-toggle="collapse" data-target="#collapse10" aria-expanded="false" aria-controls="collapse10" class="link-btn p-0 text-left border-0 bg-white w-100 d-flex justify-content-between align-items-center theme-color collapsed"><span class="font-weight-medium">Cloud & Data Center Infrastructure </span><span><i class="mdi mdi-chevron-down d-flex f-30"></i></span></button></h5>
                                </div>
                                <div id="collapse10" aria-labelledby="heading10" data-parent="#accordion" class="collapse">
                                    <div class="pt-2">
                                        <div class="service-box pt-4 d-flex align-items-start">
                                            <div class="services-info z-index">
                                                <p>Cloud Application Access Management </p>
                                                <ul>
                                                    <li>Email Protection </li>
                                                    <li>Browser Security </li>
                                                    <li>Threat Management </li>
                                                </ul>
                                            </div>
                                        </div>

                                        <div class="service-box pt-4 d-flex align-items-start">
                                            <div class="services-info z-index">
                                                <p>Infrastructure Access Management </p>
                                                <ul>
                                                    <li>Physical Access </li>
                                                    <li>Remote Access </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="service-box pt-4 d-flex align-items-start">
                                            <div class="services-info z-index">
                                                <p>Server Management </p>
                                                <ul>
                                                    <li>Operating System Patching </li>
                                                    <li>Server Security </li>
                                                    <li>Server Backups</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

            </div>
        </div>
    </section>

    <!-- assessment 2 structure-->
    <!-- <section class="section">
        <div class="container">
            <div class="row align-items-baseline">

                <div data-wow-duration="1500ms" class="col-lg-6 wow fadeInUp" style="visibility: visible; animation-duration: 1500ms;">
                    <div class="title-section">
                        <div class="subtitle-hr d-flex align-items-center">
                            <h6 class="subtitle theme-color text-uppercase position-relative">About</h6>
                            <hr>
                        </div>
                        <h2 class="title text-md-left text-center f-40">IT Governance & Security Readiness Assessment </h2>
                    </div>
                    <div class="mt-4">
                        <div id="accordion" data-wow-duration="1500ms" class="wow fadeInUp" style="visibility: visible; animation-duration: 1500ms;">
                            <div class="accordion-card bg-white mb-4 shadow rounded">
                                <div id="heading6" class="card-header border-0 p-0">
                                    <h5 class="mb-0"><button data-toggle="collapse" data-target="#collapse6" aria-expanded="false" aria-controls="collapse6" class="link-btn p-0 text-left border-0 bg-white w-100 d-flex justify-content-between align-items-center theme-color collapsed"><span class="font-weight-medium">IT Governance </span><span><i class="mdi mdi-chevron-down d-flex f-30"></i></span></button></h5>
                                </div>
                                <div id="collapse6" aria-labelledby="heading6" data-parent="#accordion" class="collapse" style="">
                                    <div class="pt-2">
                                        <div class="service-box pt-4 d-flex align-items-start">
                                            <div class="services-info z-index">
                                                <p>Corporate Structure</p>
                                                <ul>
                                                    <li>Optimal Organizational Structure Review</li>
                                                    <li>Management Analysis</li>
                                                    <li>Roles Allocation</li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="service-box pt-4 d-flex align-items-start">
                                            <div class="services-info z-index">
                                                <h6 class="text-secondary">Risk Management</h6>
                                                <ul>
                                                    <li>Risk Framework </li>
                                                    <li>Business Continuity </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="service-box pt-4 d-flex align-items-start">
                                            <div class="services-info z-index">
                                                <h6 class="text-secondary">Security Training </h6>
                                            </div>
                                        </div>
                                        <div class="service-box pt-4 d-flex align-items-start">
                                            <div class="services-info z-index">
                                                <h6 class="text-secondary">Vendor Management </h6>
                                                <ul>
                                                    <li>Protocols </li>
                                                    <li>Monitoring</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="accordion-card bg-white mb-4 shadow rounded">
                                <div id="heading7" class="card-header border-0 p-0">
                                    <h5 class="mb-0"><button data-toggle="collapse" data-target="#collapse7" aria-expanded="false" aria-controls="collapse7" class="link-btn p-0 text-left border-0 bg-white w-100 d-flex justify-content-between align-items-center theme-color collapsed"><span class="font-weight-medium">Security & Privacy</span><span><i class="mdi mdi-chevron-down d-flex f-30"></i></span></button></h5>
                                </div>
                                <div id="collapse7" aria-labelledby="heading7" data-parent="#accordion" class="collapse" style="">
                                    <div class="pt-2">
                                        <div class="service-box pt-4 d-flex align-items-start">
                                            <div class="services-info z-index">
                                                <p>Identity & Access Management </p>
                                                <ul>
                                                    <li>Access Control </li>
                                                    <li>Access Monitoring </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="service-box pt-4 d-flex align-items-start">
                                            <div class="services-info z-index">
                                                <h6 class="text-secondary">Data Security & Privacy</h6>
                                                <ul>
                                                    <li>Data Management </li>
                                                    <li>Data Protection </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="service-box pt-4 d-flex align-items-start">
                                            <div class="services-info z-index">
                                                <h6 class="text-secondary">Wireless Network Security </h6>
                                                <ul>
                                                    <li>Network Management </li>
                                                    <li>Network Protection</li>
                                                </ul>
                                            </div>
                                        </div>

                                        <div class="service-box pt-4 d-flex align-items-start">
                                            <div class="services-info z-index">
                                                <h6 class="text-secondary">Incident Monitoring </h6>
                                                <ul>
                                                    <li>People & Policy</li>
                                                    <li>Monitoring & Improvement</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="accordion-card bg-white mb-4 shadow rounded">
                                <div id="heading8" class="card-header border-0 p-0">
                                    <h5 class="mb-0"><button data-toggle="collapse" data-target="#collapse8" aria-expanded="false" aria-controls="collapse8" class="link-btn p-0 text-left border-0 bg-white w-100 d-flex justify-content-between align-items-center theme-color collapsed"><span class="font-weight-medium"> Application & Device Management </span><span><i class="mdi mdi-chevron-down d-flex f-30"></i></span></button></h5>
                                </div>
                                <div id="collapse8" aria-labelledby="heading8" data-parent="#accordion" class="collapse">
                                    <div class="pt-2">
                                        <div class="service-box pt-4 d-flex align-items-start">
                                            <div class="services-info z-index">
                                                <p>Application Whitelisting </p>
                                                <ul>
                                                    <li>Whitelisting Management </li>
                                                </ul>
                                            </div>
                                        </div>

                                        <div class="service-box pt-4 d-flex align-items-start">
                                            <div class="services-info z-index">
                                                <p>Operating System</p>
                                                <ul>
                                                    <li>Operating System Management </li>
                                                </ul>
                                            </div>
                                        </div>

                                        <div class="service-box pt-4 d-flex align-items-start">
                                            <div class="services-info z-index">
                                                <p>User Applications </p>
                                                <ul>
                                                    <li>Application Management </li>
                                                    <li>Application Hardening </li>
                                                    <li>Application Patches</li>
                                                </ul>
                                            </div>
                                        </div>

                                        <div class="service-box pt-4 d-flex align-items-start">
                                            <div class="services-info z-index">
                                                <p>Device Management </p>
                                                <ul>
                                                    <li>Protocols Review </li>
                                                    <li>o Tracking & Reporting </li>
                                                </ul>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div class="accordion-card bg-white mb-4 shadow rounded">
                                <div id="heading9" class="card-header border-0 p-0">
                                    <h5 class="mb-0"><button data-toggle="collapse" data-target="#collapse9" aria-expanded="false" aria-controls="collapse9" class="link-btn p-0 text-left border-0 bg-white w-100 d-flex justify-content-between align-items-center theme-color collapsed"><span class="font-weight-medium">User Access Control </span><span><i class="mdi mdi-chevron-down d-flex f-30"></i></span></button></h5>
                                </div>
                                <div id="collapse9" aria-labelledby="heading9" data-parent="#accordion" class="collapse">
                                    <div class="pt-2">
                                        <div class="service-box pt-4 d-flex align-items-start">
                                            <div class="services-info z-index">
                                                <p>Administrator Access Management </p>
                                                <ul>
                                                    <li>Administrator Management </li>
                                                    <li>Administrator Authentication </li>
                                                </ul>
                                            </div>
                                        </div>

                                        <div class="service-box pt-4 d-flex align-items-start">
                                            <div class="services-info z-index">
                                                <p>User Access Management </p>
                                                <ul>
                                                    <li>User Management </li>
                                                    <li>Password Management </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="accordion-card bg-white mb-4 shadow rounded">
                                <div id="heading10" class="card-header border-0 p-0">
                                    <h5 class="mb-0"><button data-toggle="collapse" data-target="#collapse10" aria-expanded="false" aria-controls="collapse10" class="link-btn p-0 text-left border-0 bg-white w-100 d-flex justify-content-between align-items-center theme-color collapsed"><span class="font-weight-medium">Cloud & Data Center Infrastructure </span><span><i class="mdi mdi-chevron-down d-flex f-30"></i></span></button></h5>
                                </div>
                                <div id="collapse10" aria-labelledby="heading10" data-parent="#accordion" class="collapse">
                                    <div class="pt-2">
                                        <div class="service-box pt-4 d-flex align-items-start">
                                            <div class="services-info z-index">
                                                <p>Cloud Application Access Management </p>
                                                <ul>
                                                    <li>Email Protection </li>
                                                    <li>Browser Security </li>
                                                    <li>Threat Management </li>
                                                </ul>
                                            </div>
                                        </div>

                                        <div class="service-box pt-4 d-flex align-items-start">
                                            <div class="services-info z-index">
                                                <p>Infrastructure Access Management </p>
                                                <ul>
                                                    <li>Physical Access </li>
                                                    <li>Remote Access </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="service-box pt-4 d-flex align-items-start">
                                            <div class="services-info z-index">
                                                <p>Server Management </p>
                                                <ul>
                                                    <li>Operating System Patching </li>
                                                    <li>Server Security </li>
                                                    <li>Server Backups</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section> -->

    <!-- End of testing section --->

    <steps></steps>

    <section class="section bg-light">
        <div class="container">
            <div class="row align-items-baseline">
                <faqs></faqs>
                <assessment-listing></assessment-listing>
            </div>
        </div>
    </section>

    <promotions></promotions>
    <contact-form></contact-form>
</div>
</template>

<script>
//WOW JS
import {
    WOW
} from 'wowjs';
//OWL CAROUSEL JS
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel';

import SalesLeadForm from '../layouts/salesLeadForm.vue';
import ContactForm from '../layouts/contactForm.vue';
import AssessmentListing from '../layouts/assessmentListing.vue';
import Steps from '../layouts/steps.vue';
import Faqs from '../layouts/faqs.vue';
import Promotions from '../layouts/promotions.vue';
import GovernaceListing from '../layouts/governanceListing.vue';

export default {
    name: 'index',
    selected: '',
    mounted() {
        this.init();
    },
    components: {
        SalesLeadForm,
        Faqs,
        AssessmentListing,
        Steps,
        ContactForm,
        GovernaceListing,
        Promotions

    },
    methods: {
        init() {
            this.initMainSlider();
            this.initWowAnimation();
            this.initTeamSlider();
            this.initClientSlider();
            this.initAccordian();
        },
        computed: {
            countries() {
                const list = countries.getNames('en', {
                    select: 'official'
                })
                return Object.keys(list).map((key) => ({
                    value: key,
                    label: list[key]
                }))
            }
        },
        /*----Main Slider----*/
        initMainSlider() {
            $('.main-slider').owlCarousel({
                loop: true,
                items: 1,
                margin: 0,
                nav: true,
                dots: true,
                autoplay: false,
                autoplayTimeout: 5000,
                items: 1,
                responsiveClass: true,
                responsive: {
                    0: {
                        items: 1,
                        nav: false,
                        dots: true
                    },
                    600: {
                        items: 1,
                        nav: false,
                        dots: true
                    },
                    1000: {
                        items: 1,
                        nav: false,
                        dots: true
                    }
                }
            });
        },
        /*----WOW ANIMATION-----*/
        initWowAnimation() {
            var length = $('.wow').length;
            if (length >= 1) {
                const wow = new WOW({
                    boxClass: 'wow',
                    animateClass: 'animated',
                    offset: 0,
                });
                wow.init();
            }
        },
        /*----TEAM SLIDER-----*/
        initTeamSlider() {
            var teamCarousel = $('.team-slider');
            if (teamCarousel.length > 0) {
                teamCarousel.owlCarousel({
                    loop: true,
                    items: 1,
                    margin: 0,
                    nav: true,
                    dots: true,
                    autoplay: false,
                    autoplayTimeout: 5000,
                    items: 2,
                    responsiveClass: true,
                    responsive: {
                        0: {
                            items: 1,
                            nav: false,
                            dots: true
                        },
                        600: {
                            items: 1,
                            nav: false,
                            dots: true
                        },
                        991: {
                            items: 2,
                            nav: false,
                            dots: true
                        }
                    }
                });
            }
        },
        /*----CLIENT SLIDER-----*/
        initClientSlider() {
            var testimonialCarousel = $('.clients-slider');
            if (testimonialCarousel.length > 0) {
                testimonialCarousel.owlCarousel({
                    loop: true,
                    items: 1,
                    margin: 0,
                    nav: true,
                    dots: true,
                    autoplay: false,
                    autoplayTimeout: 5000,
                    items: 2,
                    responsiveClass: true,
                    responsive: {
                        0: {
                            items: 1,
                            nav: false,
                            dots: true
                        },
                        600: {
                            items: 1,
                            nav: false,
                            dots: true
                        },
                        991: {
                            items: 2,
                            nav: false,
                            dots: true
                        }
                    }
                });
            }
        },
        /*----ACCORDIAN-----*/
        initAccordian() {
            $(".accordion-card").click(function () {
                if ($(this).hasClass('active')) {
                    $('.accordion-card').removeClass('active');
                    $(this).removeClass('active')
                } else {
                    $('.accordion-card').removeClass('active');
                    $(this).addClass('active')
                }
            });
        }
    }
}
</script>
